import axios from "axios";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { validationResetPassword } from "../../const/urlAction";
import { hideLoader, showLoader } from "../../redux/reducers/appLoader-reducer";
import ConvalidaResetPasswordResponse from "../../components/ConfermaResetPassword/ConvalidaResetPasswordResponse";

const urlBase = process.env.REACT_APP_URL;

export default function ConvalidaResetPassword() {
    const [statoResetPassword, setStatoResetPassword] = useState(null);
    const search = useLocation().search;
    const token = new URLSearchParams(search).get('t')
    const email = new URLSearchParams(search).get('e')
    const dispatch = useDispatch();

    useEffect(() => {
        if(token && email) {
            (async () => {
                dispatch(showLoader());
                
                const { action, method } = validationResetPassword;
                let url = urlBase + action + "?t=" + token + "&e=" + email;
                
                try {
                    const response = await axios({
                        method: method,
                        url
                    });
                    
                    if (response.data.ok) {
                        setStatoResetPassword(response.data.ok);
                    }
                } catch (error) {
                    console.error(error);
                    setStatoResetPassword(false);
                }
                dispatch(hideLoader());
            }
            )();
        }
    }, [token, email]);

    return (
        <ConvalidaResetPasswordResponse outCome={statoResetPassword} />
    );
}